import { getMessages } from '../../../../../../../../store/constants';

export const MY_WORK_BOARD_ADD = getMessages().getText('assigned_to_me.import.boards.add');
export const MY_WORK_BOARD_UPDATES_HINT = getMessages().getText('assigned_to_me.import.boards.update.hint');
